// 어드민의 글로벌 관리의 키
// 일반적인 const KEY = ''; 와 같은 형태는 string 타입으로만 지정이 가능하지만
// enum 타입을 쓰면 타입스크립트의 타입 참조가 용이 하기 때문이다.
// 2021-02-14 TS 기준 글로벌 키 값을 모두 추가 하였다.
// TODO 글로벌 키가 신규로 추가 된다면 여기에도 추가 해줘야 한다.

import { MATCH_STATUS } from 'adv-protocol/src/GameCommon'

export enum GlobalStoreKey {
  ACTIVE_BINARY_COST = 'active_binary_cost',
  ACTIVE_BINARY_COST_PROPERTY = 'active_binary_cost_property',
  ACTIVE_SUB_MARKET_COST = 'active_sub_market_cost',
  ACTIVE_SUB_MARKET_PROPERTY = 'active_sub_market_property',
  ADULT_CERTIFICATION_REQUIRED = 'adult_certification_required',
  ADULT_CERTIFICATION_PERIOD_MONTHS = 'adult_certification_period_months',
  ADULT_CERTIFICATION_FORCE_USER_NUMBER_LIST = 'adult_certification_force_user_number_list',
  ALARM_BETRADAR_STATUS = 'alarm_betradar_status',
  ALARM_TOTAL_LIVE_INFO_DELAY_SECONDS = 'alarm_total_liveinfo_delay_seconds',
  ALARM_TOTAL_LIVE_DELAY_SECONDS = 'alarm_total_live_delay_seconds',
  ALARM_TOTAL_PRE_DELAY_SECONDS = 'alarm_total_pre_delay_seconds',
  AVAILABLE_LIVE_SPORT_IDS = 'available_live_sport_ids',
  AVAILABLE_LS_LIVE_SPORT_IDS = 'available_lsports_live_sport_ids',
  AVAILABLE_MARKET_ID_LIST_HANDICAP = 'available_market_id_list_handicap',
  AVAILABLE_MARKET_ID_LIST_UNDEROVER = 'available_market_id_list_underover',
  AVAILABLE_MARKET_ID_LIST_WDL = 'available_market_id_list_wdl',
  AVAILABLE_LS_MARKET_ID_LIST_HANDICAP = 'available_lsports_market_id_list_handicap',
  AVAILABLE_LS_MARKET_ID_LIST_UNDEROVER = 'available_lsports_market_id_list_underover',
  AVAILABLE_LS_MARKET_ID_LIST_WDL = 'available_lsports_market_id_list_wdl',
  BETTING_CLOSING_RISK_NOTIFICATION_TIME = 'betting_closing_risk_notification_time',
  BETTING_HISTORY_SHARE_DAY_OFFSET = 'betting_history_share_day_offset',
  BETTING_HISTORY_SHARE_ENABLED = 'betting_history_share_enabled',
  BETTING_PENALTY_SINGLE = 'betting_penalty_single',
  BETTING_PENALTY_SINGLE_USER_LIST = 'betting_penalty_single_user_list',
  BETTOR_COMMISSION = 'bettor_commision',
  BITCOIN_BET_READY_TIME = 'bitcoin_bet_ready_time',
  BUCKET_PREFIX_ATTENDANCE_IMAGE = 'bucket_prefix_attendance_image',
  BUCKET_PREFIX_CLIENT = 'bucket_prefix_client',
  BUCKET_PREFIX_MISSION_IMAGE = 'bucket_prefix_mission_image',
  BUCKET_PREFIX_POPUP_NOTICE_IMAGE = 'bucket_prefix_popup_notice_image',
  BUCKET_PREFIX_SHOP_IMAGE = 'bucket_prefix_shop_image',
  BUCKET_PREFIX_SHOP_IMAGE_M = 'bucket_prefix_shop_image_m',
  CARRY_MAX_CASH = 'carry_max_cash',
  CARRY_MAX_EXP = 'carry_max_exp',
  CARRY_MAX_HEART = 'carry_max_heart',
  CARRY_MAX_MAIL = 'carry_max_mail',
  CARRY_MAX_MILEAGE = 'carry_max_mileage',
  CARRY_MAX_MONEY = 'carry_max_money',
  CARRY_MAX_POINT = 'carry_max_point',
  CARRY_MAX_TICKET = 'carry_max_ticket',
  CHATTING_OPTIONS = 'chatting_options',
  CHAT_ATTACH_IMAGE_URL_PREFIX = 'chat_attach_image_url_prefix',
  CHAT_BET_HISTORY_HIDDEN_REASON_OPTIONS = 'chat_bet_history_hidden_reason_options',
  CHAT_EMOTICON_URL_PREFIX = 'chat_emoticon_url_prefix',
  CHAT_IMG_HIDDEN_REASON_OPTIONS = 'chat_img_hidden_reason_options',
  CHAT_CONTENTS_HIDDEN_REASON_OPTIONS = 'chat_contents_hidden_reason_options',
  CLUB_COMMISSION = 'club_commision',
  CLUB_GMONEY_MAX_BET_LIMIT_ON_OFF = 'club_gmoney_max_bet_limit_on_off',
  CLUB_PROMOTION_ENABLED = 'club_promotion_enabled',
  COUPON_ENABLED = 'coupon_enabled',
  CS_ALARM_MINUTE = 'cs_alarm_minute',
  DAILY_MISSION_COUNT = 'daily_mission_count',
  DEFAULT_GUEST_CLUB = 'default_guest_club',
  DIRTY_ACCOUNT_LIMIT = 'dirty_account_limit',
  EMBLEM_URL_PREFIX = 'emblem_url_prefix',
  EVENT_PROFIT_ON_OFF = 'event_profit_onoff',
  EVENT_PROFIT_URL = 'event_profit_url',
  EVENT_PROFIT_URL_M = 'event_profit_url_m',
  EXTRA_INNING_INFO_VISIBLE_SPORT_IDS = 'extra_inning_info_visible_sport_ids',
  NO_EXTRA_INNING_INFO_VISIBLE_SPORT_IDS = 'no_extra_inning_info_visible_sport_ids',
  FIRST_BET_MONEY_REWARD = 'first_bet_money_reward',
  FIRST_BET_MONEY_REWARD_GOAL = 'first_bet_money_reward_goal',
  FIRST_BET_MONEY_REWARD_ITEM_CODE = 'first_bet_money_reward_item_code',
  GIFT_HEART_ON_OFF = 'gift_heart_on_off',
  GIFT_TICKET_ON_OFF = 'gift_ticket_on_off',
  GUIDE_BONUS = 'guide_bonus',
  GUIDE_BONUS_DELAY_TIME = 'guide_bonus_delay_time',
  HEART_MONEY_RATIO = 'heart_money_ratio',
  INITIAL_USER_CASH = 'initial_user_cash',
  INITIAL_USER_EXP = 'initial_user_exp',
  INITIAL_USER_HEART = 'initial_user_heart',
  INITIAL_USER_ITEM = 'initial_user_item',
  INITIAL_USER_MILEAGE = 'initial_user_mileage',
  INITIAL_USER_MONEY = 'initial_user_money',
  INITIAL_USER_PROPERTY = 'initial_user_property',
  ITEM_IMG_M_URL_PREFIX = 'item_img_m_url_prefix',
  LIMIT_TOTAL_LIVE_INFO_DELAY_SECONDS = 'limit_total_liveinfo_delay_seconds',
  LIMIT_TOTAL_LIVE_DELAY_SECONDS = 'limit_total_live_delay_seconds',
  LIMIT_TOTAL_PRE_DELAY_SECONDS = 'limit_total_pre_delay_seconds',
  LIVE_BET_DELAY_SEC_DIVIDE_PER_TOURNAMENT = 'live_bet_delay_sec_divide_per_tournament',
  LIVE_BET_DELAY_SEC_PER_TOURNAMENT = 'live_bet_delay_sec_per_tournament',
  LIVE_MATCH_AVAILABLE_CLUBS = 'live_match_available_clubs',
  LIVE_MATCH_STATUS_DELAYED_INTERVAL_TIME = 'live_match_status_delayed_interval_time',
  MAIL_RETENTION_PERIOD = 'mail_retention_period',
  MATCHUP_FETCH_ITEMS_BASE_DAYS = 'matchup_fetch_items_base_days',
  MATCH_CHANGE_BASE_DAYS = 'match_change_base_days',
  MATCH_CLOSE_DELAYED_TIME = 'match_close_delayed_time',
  MATCH_CLOSE_DELAYED_ALARM_INTERVAL_TIME = 'match_close_delayed_alarm_interval_time',
  MATCH_HASH_TAG_FOR_3 = 'match_hash_tag_for_3',
  MESSAGE_LIFE_TIME_BASIC = 'message_life_time_basic',
  MESSAGE_LIFE_TIME_BETTING_HISTORY_SHARE = 'message_life_time_betting_history_share',
  MESSAGE_LIFE_TIME_FIRST_BET_MONEY_REWARD = 'message_life_time_first_bet_money_reward',
  MESSAGE_LIFE_TIME_GUIDE_BONUS = 'message_life_time_guide_bonus',
  MESSAGE_LIFE_TIME_MISSION = 'message_life_time_mission',
  MISSION_ENABLED = 'mission_enabled',
  MONTHLY_PAYMENT_LIMIT = 'monthly_payment_limit',
  MSG_PICK_ADD_COST = 'msg_pick_add_cost',
  MSG_PICK_ADD_COST_PROPERTY = 'msg_pick_add_cost_property',
  MY_BANK_ITEM_HISTORY_DAY_OFFSET = 'mybank_item_history_day_offset',
  NO_CHATTING_TIME_OPTIONS = 'no_chatting_time_options',
  OVERLAP_LOGIN_FOR_ODDS = 'overlap_login_for_odds',
  PERIOD_EXCEPTION_MARKET_TYPE = 'period_exception_mraket_type',
  PRESENT_BOX_INTERVAL_MINUTE = 'present_box_interval_minute',
  GIFT_BOX_RESET_AT_MIDNIGHT_ENABLED = 'gift_box_reset_at_midnight_enabled',
  PRE_RESERVE_ON_OFF = 'pre_reserve_onoff',
  PRODUCT_EDITION_LIMIT_COUNT = 'product_edition_limit_count',
  PRODUCT_EDITION_LIMIT_RESET_TYPE = 'product_edition_limit_reset_type',
  REPRESENTATIVE_CLUB = 'representative_club',
  REPRESENTATIVE_CLUB_AUTO_JOIN_ON_OFF = 'representative_club_auto_join_on_off',
  REPURCHASE_PERIOD = 'repurchase_period',
  SETTLE_SUPPORT_ACTIVE_AT = 'settle_support_active_at',
  SPECIAL_GAME_ENABLED = 'special_game_enabled',
  SUB_MARKET_ON_OFF = 'sub_market_on_off',
  TABLE_VERSION_CHARACTER_DEF = 'table_version_character_def',
  TABLE_VERSION_GIFT_BOX_DEF = 'table_version_gift_box_def',
  TABLE_VERSION_GLOBAL = 'table_version_global',
  TABLE_VERSION_ITEM_DEF = 'table_version_item_def',
  TABLE_VERSION_LICENSE_DEF = 'table_version_license_def',
  TABLE_VERSION_MEMBERSHIP_DEF = 'table_version_membership_def',
  TABLE_VERSION_MISSION_DEF = 'table_version_mission_def',
  TABLE_VERSION_PRODUCT_DEF = 'table_version_product_def',
  TICKET_MONEY_RATIO = 'ticket_money_ratio',
  UNIFY_URL_PROD = 'unify_url_prod',
  UNIFY_URL_QA = 'unify_url_qa',
  URL_BITCOIN_CHART = 'url_bitcoin_chart',
  URL_COIN_THERMOMETER_CHART = 'url_cointhermometer_chart',
  URL_DATACENTER = 'url_datacenter',
  URL_RABBIT_AND_TURTLE_CHART = 'url_rabbitand_turtle_chart',
  USER_PROFILE_DEFAULT_CHARACTER_CODE = 'user_profile_default_character_code',
  USER_PROFILE_DEFAULT_IMG_URL = 'user_profile_default_img_url',
  USER_PROFILE_DEFAULT_ITEM_CHARACTER_CODE = 'user_profile_default_item_character_code',
  V2_MENU_AVAILABLE_LIST = 'v2_menu_available_list',
  VISUALIZATION_AUTH_KEY = 'visualization_auth_key',
  VISUALIZATION_URL = 'visualization_url',
  VOC_EVENT_URL = 'voc_event_url',
  VOC_POPUP_BET_COUNT = 'voc_popup_bet_count',
  WEBVIEW_URL_MATCH_INFO = 'webview_url_match_info',
  WEBVIEW_URL_MATCH_INFO_M = 'webview_url_match_info_m',
  WEEKLY_MISSION_COUNT = 'weekly_mission_count',
  WEEKLY_MISSION_DAY = 'weekly_mission_day',
  FORBID_WORD_ALTERNATE_WORD = 'forbid_word_alternate_word',
  V2_SOCKET_SERVER_URL = 'v2_socket_server_url',
  USER_PROFILE_IMG_URL_PREFIX = 'user_profile_img_url_prefix',
  USE_LIVE_LICENSE = 'use_live_license',
  BETTING_HISTORY_SCORE_MATCH_STATUS_LIST = 'betting_history_score_match_staus_list',
  CLOSE_REQUEST_BET_TIME = 'close_request_bet_time',
  GUIDE_BONUS_ENABLED = 'guide_bonus_enabled',
  USE_DIA = 'use_dia',
  TUTORIAL_ENABLED = 'tutorial_enabled',
  PAYMENT_REWARD_EVENT_ENABLED = 'payment_reward_event_enabled',
  MESSAGE_IMAGE_ATTACH_ENABLED = 'message_image_attach_enabled',
  V2_API_SERVER_URL = 'v2_api_server_url',
  CS_TAKING_OVER_DOCUMENT_URL = 'cs_taking_over_document_url',
  GMONEY_CHARGE_INDUCE_POPUP_ENABLED = 'gmoney_charge_induce_popup_enabled',
  GMONEY_CHARGE_INDUCE_POPUP_BASE_AMOUNT = 'gmoney_charge_induce_popup_base_amount',
  SYSTEM_MESSAGE_SENDER_NICK_NAME = 'system_message_sender_nick_name',
  DIA_ADVERTISEMENT_IMAGE_DISPLAY_ENABLED = 'dia_advertisement_image_display_enabled',
  DIA_ADVERTISEMENT_IMAGE_DISPLAY_CYCLE_DAY = 'dia_advertisement_image_display_cycle_day',
  CLUB_ID_LIST_FOR_TESTING = 'club_id_list_for_testing',
  APPLE_LOGIN_ENABLED = 'apple_login_enabled',
  CASINO_ADVERTISEMENT_POPUP_DISPLAY_CYCLE_DAY = 'casino_advertisement_popup_display_cycle_day',
  CASINO_ADVERTISEMENT_POPUP_DISPLAY_ENABLED = 'casino_advertisement_popup_display_enabled',
  CASINO_ADVERTISEMENT_BUTTON_DISPLAY_ENABLED = 'casino_advertisement_button_display_enabled',
  USER_ID_LIST_FOR_TESTING = 'user_id_list_for_testing',
  BETTING_SLIP_KEEP_CART_EXPLAIN_IMAGE_DISPLAY_ENABLED = 'betting_slip_keep_cart_explain_image_display_enabled',
  FRIEND_INVITATION_ENABLED = 'friend_invitation_enabled',
  FRIEND_INVITATION_CLAIMABLE_PAST_MONTHS = 'friend_invitation_claimable_past_months',
  FRIEND_INVITATION_INVITOR_CONSUMPTION_CASH_CONDITION = 'friend_invitation_invitor_consumption_cash_condition',
  FRIEND_INVITATION_INVITOR_ALLOW_USERS_NUMBER = 'friend_invitation_invitor_allow_users_number',
  FRIEND_INVITATION_INVITOR_DENY_USERS_NUMBERS = 'friend_invitation_invitor_deny_users_number',
  TUTORIAL_VIDEO_POPUP_BUTTON_DISPLAY_ENABLED = 'tutorial_video_popup_button_display_enabled',
  TUTORIAL_VIDEO_POPUP_BUTTON_DISPLAY_DAY = 'tutorial_video_popup_button_display_day',
  TUTORIAL_VIDEO_URL = 'tutorial_video_url',
  USAGE_GUIDE_VIDEO_POPUP_OPTIONS = 'usage_guide_video_popup_options',
  LIVE_SCORE_RECOMMEND_CODES = 'live_score_recommend_codes',
  IPIN_AUTHENTICATION_ENABLED = 'ipin_authentication_enabled',
  SPORTS_FEED_MARKET_PROVIDER = 'sports_feed_market_provider',
  MESSAGE_REQUEST_WAIT_SECONDS = 'message_request_wait_seconds',
  INGAME_NOTICE_TARGET_FROM_AT = 'ingame_notice_target_from_at',
  V2_FRONT_VERSION = 'v2_front_version',
  V2_PORTAL_DELAY_LOGGING_OPTIONS = 'v2_portal_delay_logging_options',
  CLUB_GMONEY_MAX_BET_LIMIT = 'club_gmoney_max_bet_limit',
  CLUB_OUTCOME_BET_MONEY_MAX = 'club_outcome_bet_money_max',
  USER_COMMENT_ATTACH_IMAGE_URL_PREFIX = 'company_pick_comment_attach_image_url_prefix',
  GOD_BLESS_ITEM_ENABLED = 'god_bless_item_enabled',
  GOD_BLESS_ITEM_SUPPORT_BET_MONEY_TYPES = 'god_bless_item_support_bet_money_types',
  GOD_BLESS_ITEM_AVAILABLE_FOLD_CONDITION = 'god_bless_item_available_fold_condition',
  LIVE_BETABLE_MATCH_SCORE = 'live_betable_match_score',
  USER_PICK_STARTED_MATCH_TIME_LIMIT = 'user_pick_started_match_time_limit',
  USER_PICK_DAILY_REWARD_PAYMENT_MAX_COUNT = 'user_pick_daily_reward_payment_max_count',
  USER_PICK_FORBID_ENABLED = 'user_pick_forbid_enabled', // 금칙어 적용 여부.
  USER_PICK_CONTENT_MIN_LENGTH = 'user_pick_content_min_length',
  USER_PICK_S_MEMBER_REWARD_PAYMENT_SCHEDULE = 'user_pick_s_member_reward_payment_schedule',
  USER_PICK_S_MEMBER_WELCOME_MESSAGE_SEND_SCHEDULE = 'user_pick_s_member_welcome_message_send_schedule',
  USER_PICK_S_MEMBER_AUTO_REGISTER_SCHEDULE = 'user_pick_s_member_auto_register_schedule',
  MATCHUP_ETC_FILTER_ALERT_OPTIONS = 'matchup_etc_filter_alert_options',
  USER_PICK_BEST_PICK_BANNER_SHOW_SCHEDULES = 'user_pick_best_pick_banner_show_schedules',
  USER_PICK_BEST_PICK_BANNER_ENABLED = 'user_pick_best_pick_banner_enabled',
  HOME_BANNER_ROLLING_SETTINGS = 'home_banner_rolling_settings',
  HOME_MAIN_BANNER_ROLLING_SETTINGS = 'home_main_banner_rolling_settings',
  MATCH_LIST_BANNER_ORDER = 'match_list_banner_order',
  RISK_TELEGRAM_ALARM_MESSAGE_OPTIONS = 'risk_telegram_alarm_message_options',
  SELECT_PREVIOUS_USER_PICK_AS_BEST_PICK_ENABLED = 'select_previous_user_pick_as_best_pick_enabled',
  SELECT_USER_PICK_BY_REGARDLESS_CI_ENABLED = 'select_user_pick_by_regardless_ci_enabled',
  SELECT_USER_PICK_BY_REGARDLESS_ACCOUNT_ENABLED = 'select_user_pick_by_regardless_account_enabled',
  USER_PICK_USER_GRADE_NEWBIE_TO_NORMAL_CHANGE_TIME = 'user_pick_user_grade_newbie_to_normal_change_time',
  USER_REPORT_TEXT_LIST = 'user_report_text_list',
  USER_PENALTY_TIME_OPTIONS = 'user_penalty_time_options',
  USER_ACTIVITY_SCORE_OPTIONS = 'user_activity_score_options',
  USER_ACTIVITY_SCORE_DELAY_TIME = 'user_activity_score_delay_time',
  USER_PICK_WRITTEN_ACTIVITY_SCORE_OPTION = 'user_pick_written_activity_score_option',
  STAT_VISUALIZATION_MATCH_NORMAL_URL = 'stat_visualization_match_normal_url',
  STAT_VISUALIZATION_MATCH_FOCUS_URL = 'stat_visualization_match_focus_url',
  STAT_VISUALIZATION_MATCH_FOCUS_SPORT_IDS = 'stat_visualization_match_focus_sport_ids',
  STAT_VISUALIZATION_BUTTON_DISPLAY_ENABLED = 'stat_visualization_button_display_enabled',
  STAT_VISUALIZATION_BUTTON_DISPLAY_ENABLED_WHEN_EMPTY_SEASON_ID = 'stat_visualization_button_display_enabled_when_empty_season_id',
  INGAME_IMAGES_URL = 'ingame_images_url',
  INGAME_VIDEO_URL = 'ingame_video_url',
  REAL_TIME_SCORE_USER_REGISTRATION_ENABLED = 'real_time_score_user_registration_enabled',
  REAL_TIME_SCORE_ENDED_MATCH_EXPIRE_TIME = 'real_time_score_ended_match_expire_time',
  REAL_TIME_SCORE_MAX_REGISTRATION_COUNT = 'real_time_score_max_registration_count',
  RANKING_EVENT_OPTIONS = 'ranking_event_options',
  MATCH_TIME_LINE_REFRESH_INTERVAL_TIME = 'match_time_line_refresh_interval_time',
  BETTOR_FIND_BASE_SEARCH_OPTIONS = 'bettor_find_base_search_options',
  BETTOR_FIND_BET_SUCCESS_BETTOR_OPTIONS = 'bettor_find_bet_success_bettor_options',
  BETTOR_FIND_TODAY_BETTING_BETTOR_OPTIONS = 'bettor_find_today_betting_bettor_options',
  BETTOR_FIND_CUSTOM_TAB_OPTIONS = 'bettor_find_custom_tab_options',
  BETTOR_FIND_REFRESH_INTERVAL_MINUTE_TIME = 'bettor_find_refresh_interval_minute_time',
  MATCHUP_RESULT_SCORE_REFRESH_INTERVAL_SEC = 'matchup_result_score_refresh_interval_sec',
  MESSAGE_DUPLICATE_CHECK_BASE_DATE = 'message_duplicate_check_base_date',
  MESSAGE_DUPLICATE_CHECK_IGNORE_NICKS = 'message_duplicate_check_ignore_nicks',
  MESSAGE_DUPLICATE_CHECK_ENABLE = 'message_duplicate_check_enable',
  LIVE_PREVIOUS_PERIOD_MARKET_FILTER_ENABLE = 'live_previous_period_market_filter_enable',
  SCORE_MODE_ENABLED = 'score_mode_enabled',
  COMMUNICATION_BLOCK_ENABLED = 'communication_block_enabled',
  COMMUNICATION_BLOCK_EXCLUDE_PROMISE_IDS = 'communication_block_exclude_promise_ids',
  COMMUNICATION_BLOCK_USER_LIMIT_COUNT = 'communication_block_user_limit_count',
  INGAME_SNOW_EFFECT_ENABLED = 'ingame_snow_effect_enabled',
  INGAME_UI_THEME = 'ingame_ui_theme',
  CHEER_FOR_TEAM_SEARCH_DATE_RANGE = 'cheer_for_team_search_date_range',
  CHEER_FOR_TEAM_FORBID_ENABLED = 'cheer_for_team_forbid_enabled', // 금칙어 적용 여부.
  ACCOUNT_TRANSFER_OPTIONS = 'account_transfer_options',
  /** 가상계좌 클린 캠페인 팝업 노출 대상 회원 닉네임 목록 */
  VA_CLEAN_CAMPAIGN_TARGET_USER_NICKS = 'va_clean_campaign_target_user_nicks',
  CHAT_CONTENT_BUTTON_OPTIONS = 'chat_content_button_options',
  POPULAR_SEARCH_TERM_OPTIONS = 'popular_search_term_options',
  MAJOR_USER_GROUP_MESSAGE_SEND_SCHEDULE = 'major_user_group_message_send_schedule',
  MAJOR_USER_GROUP_REWARD_PAYMENT_SCHEDULE = 'major_user_group_reward_payment_schedule',
  MAJOR_USER_GROUP_MY_PAGE_THEME_SETTINGS = 'major_user_group_my_page_theme_settings',
  MAJOR_USER_GROUP_IMAGE_URL_PREFIX = 'major_user_group_image_url_prefix',
  MINIMUM_LIVE_MATCH_OUTCOME_RATE = 'minimum_live_match_outcome_rate',
  MESSAGE_AUTO_DELETE_OPTIONS = 'message_auto_delete_options',
  MATCH_INSIGHT_IMAGE_URL_PREFIX = 'match_insight_image_url_prefix',
  POPULAR_SEARCH_TERM_AUTO_DELETE_SCHEDULE = 'popular_search_term_auto_delete_schedule',
  SPORT_TALK_MATCH_TIMELINE_OPTIONS = 'sport_talk_match_timeline_options',
  CHAMPPOKER_DEEPLINK_OPTIONS = 'champpoker_deeplink_options',
  SPORT_TALK_DASHBOARD_OPTIONS = 'sport_talk_dashboard_options',
  AUTO_GENERATE_SPORT_TALK_BY_CHAT_MESSAGE_ENABLED = 'auto_generate_sport_talk_by_chat_message_enabled',
  UNCONFIGURED_META_MARKET_ALARM_MINUTE = 'unconfigured_meta_market_alarm_minute',
  FAVORITE_USER_COUNT_LIMIT = 'favorite_user_count_limit',
  CHAT_FLOOD_CONTROL_OPTIONS = 'chat_flood_control_options',
  CHAT_FLOOD_EXCLUDE_USER_NUMBER_LIST = 'chat_flood_exclude_user_number_list',
  REQUIRED_LOSS_LIMIT_SETTING_POPUP = 'required_loss_limit_setting_popup',
  DAILY_CULTURE_CASH_PAYMENT_LIMIT = 'daily_culture_cash_payment_limit',
  SCHEDULE_SCORE_UPDATE_OPTIONS = 'schedule_score_update_options',
  INGAME_IMAGES_VERSION = 'ingame_images_version',
  MATCHUP_CHARGE_BUTTON_JOIN_DATE_FROM = 'matchup_charge_button_join_date_from',
}

export enum LogType {
  AUTH_KEY_LOGIN = 10001,
  LOCAL_LOGIN = 10002,
  GOOGLE_LOGIN = 10003,
  KAKAO_LOGIN = 10015,
  NAVER_LOGIN = 10016,
  APPLE_LOGIN = 10017,
}

export enum ADMIN_OPTION_KEY {
  LIVE_MATCH_STATUS_DELAYED_OPTION = 'live_match_status_delayed_option',
}

export enum V2_API_HEADER {
  ACCESS_TOKEN = 'adv-access-token',
  ACCESS_TOKEN_VALUE = 'C75283491EE20CD61164C98D8D096A29C3698804010A5F417750BD6CA5B7B760',
}

export enum V2_API_URL {
  ATTACHED_MESSAGE_IMAGE_URL = '/v2/store/awsS3/messageImage',
  CREATE_META_UNIQUE_TOURNAMENT = '/v2/meta/makeMetaUniqueTournaments',
  CREATE_META_UNIQUE_TEAM = '/v2/meta/makeMetaUniqueTeams',
  SIMPLE_MATCH_TIMELINE_GROUP_LIST = '/v2/unified/simpleMatchTimelineGroupList',
  UPLOAD_CHAT_IMAGE = '/v2/store/awsS3/uploadChatImage',
  UPLOAD_COMPANY_PICK_COMMENT_IMAGE = '/v2/store/awsS3/uploadCompanyPickCommentImage',
  UPLOAD_USER_PROFILE_IMAGE = '/v2/store/awsS3/uploadUserProfileImage',
  REFRESH_MATCH_STATUS_AND_SCORE_INFO_BY_BETRADAR = '/v2/unified/refreshMatchStatusAndScoreInfoByBetRadarApi'
}

export const TimeType = {
  M: 'minutes', H: 'hours', D: 'days', W: 'week', MO: 'months', Y: 'years', UNLIMITED: 'UNLIMITED',
}

export const TimeTypeKo = {
  M: '분', H: '시간', D: '일', W: '주일', MO: '개월', Y: '년', UNLIMITED: '영구 제재',
}

export const ChatMessageUpdateType = {
  STATE: 'state', VISIBLE_CONTENTS: 'visibleContents', VISIBLE_ATTACHMENT: 'visibleAttachment',
}

export enum ADMIN_ROLE {
  UNDEFINED,
  MASTER,
  USER,
  ADMIN,
}

export const CHARACTER_CHECK_EXPRESSION = {
  KOREAN: /^[가-힣a-zA-Z\d]+$/,
  ENGLISH: /[a-z]/gi,
  ENGLISH_UPPER_CASE: /[A-Z]/g,
  ENGLISH_LOWER_CASE: /[a-z]/g,
  NUMBER: /[0-9]/gi,
  SPECIAL: /[`~!@#$%^&*|\\'';:/?]/gi,
}

export const DEFAULT_REDEMPTION_RATE = {
  LIVE: 100, CROSS: 80,
}

/**
 * 메인화면 중간 탭 선택
 * @enum
 */
export const EXCEPTIONAL_SPORT_ID_GROUP = {
  /** 기타 0 */
  ETC: 0, // 기타
  /** 전체 -1 */
  ALL: -1, // 전체
  /** HOT -2 */
  HOT: -2, // HOT
  /** 찜 -3 */
  FAVORITE: -3, // 찜
}

/**
 * 메인화면 마지막 탭 선택
 * @enum
 */
export const EXCEPTIONAL_UNIQUE_ID = {
  // 1 이상: 특정 리그
  /** 전체 0 */
  MINOR_LEAGUE: 0, // 전체
  /** 주요리그 -1 */
  MAJOR_LEAGUE: -1, // 주요리그
  /** 전체리그 -2 */
  TOTAL_LEAGUE: -2, // 전체리그
  /** 찜한경기 -3 */
  FAVORITE_MATCH: -3, // 찜한경기
  /** 진행중 경기 -4 */
  PROGRESSING_MATCH: -4, // 진행중경기
  /** 리그 필터 -5 */ // 리그 필터로 필터링 된 경기
  LEAGUE_FILTERED_MATCH: -5,
  /** 시작전 매치 */
  NOT_STARTED_USER_PICK: -6,
  /** 시작된 매치 */
  STARTED_USER_PICK: -7,
  /** 종료된 매치 **/
  CLOSED_USER_PICK: -8,
  /** 승무패 분석글 */
  WAY_USER_PICK: -9,
  /** 언더오버 분석글 */
  UO_USER_PICK: -10,
  /** 핸디캡 분석글 */
  HANDI_USER_PICK: -11,
  /** 기타 마켓 분석글 */
  ETC_USER_PICK: -12,
  /** 전체 마켓 분석글 */
  TOTAL_USER_PICK: -13,
  /** 마이베팅 경기 -14 */
  MY_BET_MATCH: -14, // 마이베팅경기
}

export enum MESSAGE_RECEIVER_TYPE {
  ALL_USER,
  USER_GROUP,
  TARGET_USER
}

export const MESSAGE_ATTACH_IMAGE_URL: string = 'data_center/message/images'

export enum MISSION_STATE {
  NONE, // 미션 시작전
  WORKING, // 미션 진행중
  WORK_DONE, // 미션 완료
  FINISH, // 미션 보상 완료.
}

export enum MISSION_GAME_TYPE {
  BETTING, BACCARAT
}

export enum MESSAGE_SOURCE {
  BETTING, CASINO
}

export enum GIFT_BOX_TYPE {
  GIFT_BOX, DOUBLE_ROULETTE,
}

export enum GIFT_BOX_SUB_TYPE {
  NONE, DOUBLE_ROULETTE_BIG, DOUBLE_ROULETTE_SMALL,
}

export enum EVENT_TYPE {
  DAILY, ONCE, PERIOD, STEP,
}

export enum EVENT_GOAL_TYPE {
  COUNT, PRICE
}

export enum GAME_KIND {
  BETTING, CASINO
}

export enum GAME_BANNER_TYPE {
  EVENT,
  RECOMMEND_CLUB_IN_GIFT_BOX,
  ADVERTISEMENT_IN_GIFT_BOX,
  LIVE_BET_EVENT,
  EXTRA_PAYMENT_REWARD_EVENT,
}

export enum GAME_BANNER_STATE {
  UNPUBLISHED = 0,
  PUBLISHED = 1,
}

export enum GAME_BANNER_POST_TYPE {
  HOME,
  CLUB_EVENT,
  MATCHUP_BOTTOM,
  MATCHUP_LIST,
  MAINTENANCE,
  BETTING_HISTORY,
  CHAT
}

export const GAME_BANNER_ENABLED_COLUMN_NAME = {
  [GAME_BANNER_POST_TYPE.HOME]: 'homePostEnabled',
  [GAME_BANNER_POST_TYPE.CLUB_EVENT]: 'clubEventPostEnabled',
  [GAME_BANNER_POST_TYPE.MATCHUP_BOTTOM]: 'matchupBottomPostEnabled',
  [GAME_BANNER_POST_TYPE.MATCHUP_LIST]: 'matchupListPostEnabled',
  [GAME_BANNER_POST_TYPE.MAINTENANCE]: 'maintenancePostEnabled',
  [GAME_BANNER_POST_TYPE.BETTING_HISTORY]: 'bettingHistoryPostEnabled',
  [GAME_BANNER_POST_TYPE.CHAT]: 'chatPostEnabled',
}

export const GAME_BANNER_IMAGE_COLUMN_NAME = {
  BANNER_IMAGE: 'bannerImage',
  CONTENTS_IMAGE: 'contentsImage',
  HOME_IMAGE: 'homeImage',
  BUTTON_IMAGE: 'buttonImage',
  MATCHUP_BOTTOM_IMAGE: 'matchupBottomImage',
}

export const GAME_HOME_MAIN_BANNER_COLUMN_NAME = {
  MOBILE_IMAGE: 'mobileImage',
  PC_IMAGE:'pcImage',
}

export enum GAME_BANNER_DETAIL_BUTTON_TYPE {
  DOWNLOAD_AOS,
  DOWNLOAD_IOS,
}

export enum PROPERTY_EXCHANGE_TYPE {
  DIA_TO_DIA_CHIP, DIA_CHIP_TO_DIA,
}

export const ADMIN_PROPERTY_CONSUME_TYPE_DESC_DEFAULT_TEXT = '운영자 회수'
export const ADMIN_PROPERTY_CHARGE_TYPE_DESC_DEFAULT_TEXT = '운영자 지급'

export enum FEED_SUPPLIER {
  BET_RADAR = 'betradar', LSPORTS = 'lsports',
}

export enum MARKET_PROVIDER {
  BET_RADAR = 0, BET_365 = 8, B_WIN = 13, SBO_BET = 36, ONE_X_BET = 145,
  // Lsports STM
  LS_STM = 9999,
}

export enum NOTICE_CATEGORY {
  NOTICE = 'notice',
  RULE = 'rule',
  EVENT = 'event',
  MEDIA = 'media',
  TIP = 'tip'
}

export enum NOTICE_STATE {
  DISABLED,
  ENABLED,
}

export enum NOTICE_POSITION {
  NORMAL,
  TOP,
}

export enum TEAM_POSITION {
  HOME = 1, AWAY = 2,
}

export enum LS_PERIOD_TYPE {
  NOT_STARTED_YET = -1,
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
  FORTH = 4,
  FIFTH = 5,
  SIXTH = 6,
  SEVENTH = 7,
  EIGHTH = 8,
  NINTH = 9,
  FIST_HALF = 10,
  SECOND_HALF = 20,
  OVER_TIME_FIRST_HALF = 30,
  OVER_TIME_SECOND_HALF = 35,
  OVER_TIME = 40,
  PENALTIES_GOLDEN_SET = 50,
  GAME = 60,
  ERROR = 62,
  ROUND = 65,
  FRAME = 66,
  LEG = 67,
  OVER = 70,
  DELIVERY = 71,
  BREAK_TIME = 80,
  NONE = 99,
  FULL_TIME = 100,
  FULL_TIME_AFTER_OVER_TIME = 101,
  FULL_TIME_AFTER_PENALTIES = 102,
}

export enum LS_STATUS_DESC {
  UNKNOWN = -1,
  NONE = 0,
  HALFTIME = 1,
  OVERTIME_HALFTIME = 2,
  HOME_PARTICIPANT_HAS_RETRIED = 3,
  AWAY_PARTICIPANT_HAS_RETRIED = 4,
  COVERAGE_FOR_THIS_EVENT_HAS_BEEN_LOST = 5,
  MEDICAL_TIMEOUT = 6,
  TIMEOUT_OF_HOME_TEAM = 7,
  TIMEOUT_OF_AWAY_TEAM = 8,
  TIMEOUT = 9, // when team is not known
  HOME_WALKOVER = 10,
  AWAY_WALKOVER = 11,
}

/**
 * Lsports Fixture Status
 */
export enum LS_FIXTURE_STATUS {
  NOT_STARTED = 1,
  IN_PROGRESS = 2,
  FINISHED = 3,
  CANCELLED = 4,
  POSTPONED = 5,
  INTERRUPTED = 6,
  ABANDONED = 7,
  COVERAGE_LOST = 8,
  ABOUT_TO_START = 9,
  PENDING_FINISHED = 10,
}

export enum LS_BET_STATUS {
  NOT_SET = 0,
  OPEN = 1,
  SUSPENDED = 2,
  SETTLED = 3,
}

export enum LS_BET_SETTLEMENT_STATUS {
  CANCELLED = -1,
  NOT_SETTLED = 0,
  LOSER = 1,
  WINNER = 2,
  REFUND = 3,
  HALF_LOST = 4,
  HALF_WON = 5,
}

export enum LS_MESSAGE_TYPE {
  FULL_EVENT = 0,
  FIXTURE_UPDATE = 1,
  LIVE_SCORE_UPDATE = 2,
  MARKET_UPDATE = 3,
  LEAGUES = 4,
  SPORTS5 = 5,
  LOCATIONS = 6,
  MARKETS = 7,
  BOOK_MAKERS = 8,
  KEEP_ALIVE = 31,
  HEARTBEAT = 32,
  SETTLEMENT_UPDATE = 35,
  IN_PLAY_SNAPSHOT = 36,
  OUTRIGHT_FIXTURE_METADATA = 37,
  OUTRIGHT_LEAGUE = 38,
}

export enum LS_SCORE_STATISTIC_TYPE {
  NOT_SET = 0,
  CORNERS = 1,
  SHOTS_ON_TARGET = 2,
  SHOTS_OFF_TARGET = 3,
  ATTACKS = 4,
  DANGEROUS_ATTACKS = 5,
  YELLOW_CARD = 6,
  RED_CARD = 7,
  PENALTIES = 8,
  GOAL = 9,
  SUBSTITUTIONS = 10,
  POSSESSION = 11,
  FOULS = 12,
  FREE_KICKS = 13,
  GOAL_KICKS = 14,
  OFFSIDES = 0xF,
  BLOCKED_SHOTS = 0x10,
  THROW_INS = 17,
  WOODWORK_SHOTS = 18,
  CLEARANCE = 19,
  ACES = 20,
  DOUBLE_FAULTS = 21,
  SERVICE_POINTS = 22,
  BREAK_POINTS = 23,
  OWN_GOAL = 24,
  PENALTY_GOAL = 25,
  SCORE = 27,
  TWO_POINTS = 28,
  PCT = 29,
  THREE_POINTS = 30,
  TIME_OUTS = 31,
  FREE_THROWS = 32,
  HITS = 33,
  FIRST_SERVE_WINS = 34,
  BALL = 35,
  WICKET_TAKEN = 36,
  WIDE_BALL = 37,
  NO_BALL = 38,
  LEG_BYE = 39,
  MISSED_PENALTY = 40,
  CARDS = 41,
}

export enum NOTICE_REQUEST_TYPE {
  NORMAL,
  MATCH_UP,
}

export const AUTHENTICATION_CACHE_KEY_PREFIX = 'authenticationCache:'
export const ACCOUNT_LENGTH = { MIN: 4, MAX: 12 }
export const PASSWORD_LENGTH = { MIN: 8, MAX: 16 }
export const NICKNAME_LENGTH = { MIN: 2, MAX: 8 }
export const EMAIL_LENGTH = { MIN: 6, MAX: 60 }

export const V2_EXPRESS_SESSION_KEY_PREFIX = 'sess_v2_express:'
export const V2_PORTAL_SESSION_KEY_PREFIX = 'sess_v2_portal:'
export const V2_SOCKET_SESSION_KEY_PREFIX = 'sess_v2_socket:'
export const CASINO_SESSION_KEY_PREFIX = 'sess_casino_portal:'
export const ADMIN_SESSION_KEY_PREFIX = 'sess_admin_srv:'
export const REPORT_SESSION_KEY_PREFIX = 'sess_report:'
export const PRM_SESSION_KEY_PREFIX = 'sess_prm:'
export const DE_SESSION_KEY_PREFIX = 'sess_data_extractor:'
export const HOME_SESSION_KEY_PREFIX = 'sess_web_home:'
export const CLUB_SOLUBLE_INFO_GAIN_LOSS = 'adv_club:soluble_info:gainLoss'
export const CS_USER_RATING_ON_ANSWER = { MIN: 1, MAX: 5 }
export const CS_USER_FEEDBACK_ON_ANSWER = { MIN: 0, MAX: 200 }
export const V2_TODAY_BETTING_BETTOR_PREFIX = 'adv_v2_portal:bettorFind:todayBettingBettor'

export const PASSWORD_KEYBOARD_SEQUENCE_WORDS = [
  'qwe', 'wer', 'ert', 'rty', 'tyu', 'yui', 'uio', 'iop', 'asd', 'sdf',
  'dfg', 'fgh', 'ghj', 'hjk', 'jkl', 'zxc', 'xcv', 'cvb', 'vbn', 'bnm',
  'mnb', 'nbv', 'bvc', 'vcx', 'cxz', 'lkj', 'kjh', 'jhg', 'hgf', 'gfd',
  'fds', 'dsa', 'poi', 'oiu', 'iuy', 'uyt', 'ytr', 'tre', 'rew', 'ewq',
  '890', '098', '987', '876', '654', '543', '432', '321',
  '!@#', '@#$', '#$%', '$%^', '%^&', '^&*',
  '*&^', '&^%', '^%$', '%$#', '$#@', '#@!',
]

export enum ATTACHMENT_TYPE {
  TEXT_ONLY, EMOTICON, IMAGE, BET_HISTORY, USER_PICK, AUTO_GENERATE_BET_HISTORY = 5
}

export const BETTING_CANCELLATION_MATCH_EXCLUSION_TIME = { CLUB: 1, BETTOR: 5 }

/**
 * 특정 상황에서 어떤 뷰로 부터 컴포넌트를 추가 한것인지 파악하는 용도.
 */
export enum FROM_VIEW_TYPE {
  // 승부사온라인 홈
  ADV_HOME,
  // 나도승부사 분석글 매치 목록
  USER_PICK_MATCH_LIST,
  // 나도승부사 분석글 목록
  USER_PICK_PICK_MATCH,
  // 리그 필터 팝업창
  MATCHUP_FILTER,
  BETTING_HISTORY,
  // 메인 매치업 화면
  MAIN_MATCHUP,
  TODAY_USER_PICK_POPUP,
  USER_PICK,
  COMPANY_PICK_COMMENT,
  USER_PICK_COMMENT,
  //상세 BET - 응원글 탭
  MATCHUP_DETAIL_CHEER_FOR_TEAM,
  //상세 BET - 분석글 탭
  MATCHUP_DETAIL_PICK,
  // 채팅
  CHAT,
  // 베팅 슬립
  BET_SLIP_BOTTOM,
  // 퀵 메시지
  QUICK_MESSAGE,
  // 마이 뱅크
  MONEY_HISTORY_LIST,
  // 유저 상세
  USER_DETAIL_INFO,
  // 메시지
  MESSAGE,
  // 공유 베팅 슬립
  COMPONENT_BET_SLIP,
  // 미사용
  BUBBLE_BET_LIST,
  // 프리미엄 분석가
  COMPANY_PICK,
  // 베터 찾기
  BETTOR_FIND,
  // 스포츠톡 팝업
  SPORT_TALK,
  // 마이 프로필 작성한 댓글
  MY_PROFILE_COMMENT,
}

export enum RISK_TELEGRAM_ALARM_ACTION_TYPE {
  V2_LOGIN,
  BETTING,
  PAY,
  V1_LOGIN,
  HOME_LOGIN,
  REGISTER_LOCAL,
  REGISTER_NAVER,
  REGISTER_GOOGLE,
  REGISTER_APPLE,
  SEND_MESSAGE,
  V2_SOCKET,
}

/**
 * 고정배 또는 나도승부사를 작성한 유저인지 구분
 */
export enum PICK_WRITER_TYPE {
  COMPANY_PICK,
  USER_PICK,
}

export enum USER_LIKE_TYPE {
  COMPANY_PICK,
  COMPANY_PICK_COMMENT,
  USER_PICK,
  USER_PICK_COMMENT,
}

export enum USER_COMMENT_TYPE {
  COMPANY_PICK_COMMENT,
  USER_PICK_COMMENT,
}

export enum USER_COMMENT_SOURCE_TYPE {
  COMPANY_PICK_COMMENT,
  COMPANY_PICK_COMMENT_REPLY,
  USER_PICK_COMMENT,
  USER_PICK_COMMENT_REPLY,
}

/**
 * 신고 종류
 */
export enum USER_REPORT_TYPE {
  COMPANY_PICK,
  COMPANY_PICK_COMMENT,
  USER_PICK,
  USER_PICK_COMMENT,
  CHEER_FOR_TEAM,
}

/**
 * 신고 처리 결과 종류
 */
export enum USER_REPORT_RESULT {
  WAITING,
  PENDING,
  EXCLUDE,
  PROCESSED,
}

/**
 * 유저 패널티 종류
 */
export enum USER_PENALTY_TYPE {
  COMPANY_PICK, // 회사픽 [고정배, 프리미엄 분석가] 댓글, 답글 작성 불가
  USER_PICK, // 나도 승부사 분석글, 댓글, 답글 작성 불가
  CHATTING, // 채팅 작성 불가 (채팅 응원글 포함)
  CHEER_FOR_TEAM// 응원글 작성 불가
}

export enum COMMUNICATION_BLOCK_TYPE {
  USER_PICK,
  PICK_COMMENT,
  MESSAGE,
  CHAT_AND_SPORT_TALK,
}

export enum EDITOR_MODE {
  COMPANY_PICK_COMMENT,
  USER_PICK_COMMENT,
  USER_PICK,
}

export enum BETTOR_FIND_TYPE {
  NEW_MEMBER,
  FIRST_BET,
  BET_HIT_SUCCESS,
  ALL_BETTOR,
  TODAY_BETTOR,
  CUSTOM_TAB,
}

export enum BETTOR_FIND_CUSTOM_TAB_TYPE {
  QUIZ_WINNER = 0,
}

export const PlayingPeriodSpecifierKey = [
  'quarternr',
  'inningnr',
  'setnr',
  'gamenr',
  'mapnr',
  'goalnr',
  'framenr',
  'periodnr',
  'pointnr',
  'runnr',
]

export const SoccorPeriodMatchStatus: MATCH_STATUS[] = [
  MATCH_STATUS.FirstHalf,
  MATCH_STATUS.SecondHalf,
]

export const BasketballPeriodMatchStatus: MATCH_STATUS[] = [
  MATCH_STATUS.FirstQuarter,
  MATCH_STATUS.SecondQuarter,
  MATCH_STATUS.ThirdQuarter,
  MATCH_STATUS.FourthQuarter,
]

export const IceHockeyPeriodMatchStatus: MATCH_STATUS[] = [
  MATCH_STATUS.FirstPeriod,
  MATCH_STATUS.SecondPeriod,
  MATCH_STATUS.ThirdPeriod,
  MATCH_STATUS.FourthPeriod,
  MATCH_STATUS.FifthPeriod,
]
export const BaseballPeriodMatchStatus = [
  MATCH_STATUS.FirstInningTop,
  MATCH_STATUS.FirstInningBottom,
  MATCH_STATUS.SecondInningTop,
  MATCH_STATUS.SecondInningBottom,
  MATCH_STATUS.ThirdInningTop,
  MATCH_STATUS.ThirdInningBottom,
  MATCH_STATUS.FourthInningTop,
  MATCH_STATUS.FourthInningBottom,
  MATCH_STATUS.FifthInningTop,
  MATCH_STATUS.FifthInningBottom,
  MATCH_STATUS.SixthInningTop,
  MATCH_STATUS.SixthInningBottom,
  MATCH_STATUS.SeventhInningTop,
  MATCH_STATUS.SeventhInningBottom,
  MATCH_STATUS.EighthInningTop,
  MATCH_STATUS.EighthInningBottom,
  MATCH_STATUS.NinthInningTop,
  MATCH_STATUS.NinthInningBottom,
]

export const VollyballPeriodMatchStatus: MATCH_STATUS[] = [
  MATCH_STATUS.FirstSet,
  MATCH_STATUS.SecondSet,
  MATCH_STATUS.ThirdSet,
  MATCH_STATUS.FourthSet,
  MATCH_STATUS.FifthSet,
  MATCH_STATUS.GoldenSet,
]

export const TableTenisPeriodMatchStatus: MATCH_STATUS[] = [
  MATCH_STATUS.FirstSet,
  MATCH_STATUS.SecondSet,
  MATCH_STATUS.ThirdSet,
  MATCH_STATUS.FourthSet,
  MATCH_STATUS.FifthSet,
]


export const PlayingPeriodSpecifierKeyByGoalnr = 'goalnr'
export const PlayingPeriodSpecifierKeysByScore = [
  'goalnr',
  'pointnr',
]

/**
 * PG 사 결제 타입 (2, 3, 4 ... )
 * - VA: 가상계좌 (값: 2)
 * - MC: 휴대폰 (값: 3)
 * - CN: 신용카드 (값: 4)
 * - GM: 컬쳐랜드 (값: 5)
 * - GG: 스마트문상 (값: 6)
 * - GC: 도서문화상품권 (값: 7)
 * - TM: 모바일티머니 (값: 8)
 * - RA: 계좌이체 (값: 9)
 * - TC: 캐시비 (값: 10)
 * - HM: 해피머니 (값: 11)
 * - FC: 퍼니카드 (값: 12)
 */
export enum PG_TYPE {
  /**
   - 가상계좌 (값: 2)
   */
  VA = 2,

  /**
   - 휴대폰 (값: 3)
   */
  MC = 3,

  /**
   - 신용카드 (값: 4)
   */
  CN = 4,

  /**
   - 문화상품권 (값: 5)
   */
  GM = 5,

  /**
   - 스마트문상 (값: 6)
   */
  GG = 6,

  /**
   - 도서문화상품권 (값: 7)
   */
  GC = 7,

  /**
   - 모바일티머니 (값: 8)
   */
  TM = 8,

  /**
   - 계좌이체 (값: 9)
   */
  RA = 9,

  /**
   - 캐시비 (값: 10)
   */
  TC = 10,

  /**
   - 해피머니 (값: 11)
   */
  HM = 11,

  /**
   - 퍼니카드 (값: 12)
   */
  FC = 12,
}

/**
 * PG 사 결제 타입 코드 (VA, MC, CN ..)
 * - VA: 가상계좌 (값: VA)
 * - MC: 휴대폰 (값: MC)
 * - CN: 신용카드 (값: CN)
 * - GM: 문화상품권 (값: GM)
 * - GG: 스마트문상 (값: GG)
 * - GC: 도서문화상품권 (값: GC)
 * - TM: 모바일티머니 (값: TM)
 * - RA: 계좌이체 (값: RA)
 * - TC: 캐시비 (값: TC)
 * - HM: 해피머니 (값: HM)
 * - FC: 퍼니카드 (값: FC)
 */
export enum PG_TYPE_CODE {

  /**
   - 가상계좌 (값: VA)
   */
  VA = 'VA',

  /**
   - 휴대폰 (값: MC)
   */
  MC = 'MC',

  /**
   - 신용카드 (값: CN)
   */
  CN = 'CN',

  /**
   - 컬쳐랜드 (값: GM)
   */
  GM = 'GM',

  /**
   - 스마트문상 (값: GG)
   */
  GG = 'GG',

  /**
   - 도서문화상품권 (값: GC)
   */
  GC = 'GC',

  /**
   - 모바일티머니 (값: TM)
   */
  TM = 'TM',

  /**
   - 계좌이체 (값: RA)
   */
  RA = 'RA',

  /**
   - 캐시비 (값: TC)
   */
  TC = 'TC',

  /**
   - 해피머니 (값: HM)
   */
  HM = 'HM',

  /**
   - 퍼니카드 (값: FC)
   */
  FC = 'FC',
}

/**
 * 결제 상태 값
 *
 * - PENDING: 입금 대기
 * - NORMAL: 입금 완료
 * - CANCELED: 환불 (admin 을 통한 PG사 결제 취소 시)
 * - PG_CANCELED: PG사 직접 환불 (PG사 결제 취소 후 admin 에서 처리할 때, ex. 가상계좌)
 */
export enum PAY_STATE {
  PENDING,
  COMPLETE,
  CANCELED,
  PG_CANCELED
}

export enum DEVICE_TYPE {
  PC = 'pc',
  MOBILE = 'mobile',
}

export enum OS_TYPE {
  WINDOWS= 'Windows',
  IOS = 'iOS',
  ANDROID = 'Android',
  MAC = 'Mac OS',
  LINUX = 'Linux',
  UNKNOWN = 'Unknown',
}

export const USER_TITLE_ID = {
  PREMIUM_ANALYST: 1,    // 프리미엄 분석가
  HARD_ACTIVIST: 2,      // 열심 활동가
}

export const ACCOUNT_TRANSFER_DIRECT = {
  FROM: 0,
  TO: 1,
}

export enum ACCOUNT_TRANSFER_STATUS {
  PENDING,      // 계정 이관 대기
  COMPLETED,    // 계정 이관 완료
  EXCLUDED,     // 계정 이관 제외
}

export enum CHAT_CONTENT_BUTTON_TYPE {
  COMPANY_PICK,
  TODAY_USER_PICK,
  USER_ACTIVITY_SCORE,
  CHEER_FOR_TEAM
}

// 회사픽
export enum COMPANY_PICK_TYPE {
  GO_JEONG_BAE,      // 고정배
  PREMIUM_ANALYST,   // 프리미엄 분석가
}

export enum COMPANY_PICK_MANAGER_IMAGE_TYPE {
  LIST_PAGE_CHARACTER,        // 목록 페이지 캐릭터 이미지
  LIST_PAGE_BACKGROUND,       // 목록 페이지 배경 이미지
  DETAIL_PAGE_BACKGROUND,     // 상세 페이지 배경 이미지
  DETAIL_PAGE_CHARACTER,     //  경기분석창 예측 이미지
}

export const COMPANY_PICK_MANAGER_IMAGE_COLUMN_BASE_NAME = {
  LIST_PAGE_CHARACTER: 'listPageCharacter',
  LIST_PAGE_BACKGROUND: 'listPageBackground',
  DETAIL_PAGE_BACKGROUND: 'detailPageBackground',
  DETAIL_PAGE_CHARACTER: 'detailPageCharacter',
}

export const COMPANY_PICK_MANAGER_IMAGE_COLUMN_NAME = {
  LIST_PAGE_CHARACTER: `${COMPANY_PICK_MANAGER_IMAGE_COLUMN_BASE_NAME.LIST_PAGE_CHARACTER}Image`,
  LIST_PAGE_BACKGROUND: `${COMPANY_PICK_MANAGER_IMAGE_COLUMN_BASE_NAME.LIST_PAGE_BACKGROUND}Image`,
  DETAIL_PAGE_BACKGROUND: `${COMPANY_PICK_MANAGER_IMAGE_COLUMN_BASE_NAME.DETAIL_PAGE_BACKGROUND}Image`,
  DETAIL_PAGE_CHARACTER: `${COMPANY_PICK_MANAGER_IMAGE_COLUMN_BASE_NAME.DETAIL_PAGE_CHARACTER}Image`,
}

export const CLUB_IMAGE_TYPE = {
  EMBLEM_IMAGE: 'emblem_image',
  LIST_IMAGE: 'listImage',
  LIST_TEXT_IMAGE: 'listTextImage',
  BACKGROUND_IMAGE: 'backgroundImage',
  COPY_IMAGE: 'copy_image',
}

export enum POPULAR_SEARCH_TERM_NEWS_SORT {
  SIMILARL = 'sim',  // 유사도 순
  DATE = 'date',     // 기사 날짜 기준 내림 차순
}

export const MAJOR_USER_GROUP_IMAGE_COLUMN_BASE_NAME = {
  GROUP_ICON: 'groupIcon',
  GROUP_DETAIL: 'groupDetail',
  GROUP_USER_PROFILE_SKIN: 'profileSkin',
  GROUP_USER_PROFILE_BORDER_LINE: 'profileBorderLine',
}

export const MAJOR_USER_GROUP_IMAGE_COLUMN_NAME = {
  GROUP_ICON: `${MAJOR_USER_GROUP_IMAGE_COLUMN_BASE_NAME.GROUP_ICON}Image`,
  GROUP_DETAIL: `${MAJOR_USER_GROUP_IMAGE_COLUMN_BASE_NAME.GROUP_DETAIL}Image`,
  GROUP_USER_PROFILE_SKIN: `${MAJOR_USER_GROUP_IMAGE_COLUMN_BASE_NAME.GROUP_USER_PROFILE_SKIN}Image`,
  GROUP_USER_PROFILE_BORDER_LINE: `${MAJOR_USER_GROUP_IMAGE_COLUMN_BASE_NAME.GROUP_USER_PROFILE_BORDER_LINE}Image`,
}

export enum MAJOR_USER_GROUP_OPTION {
  MY_PAGE_ICON,
  MY_PAGE_SKIN,
  FORE_FRONT_POPUP,
}

export const WDL_MARKET_TYPES = [1, 186, 219, 251]
export const HANDICAP_MARKET_TYPES = [16, 223, 256, 237]
export const UNDEROVER_MARKET_TYPES = [18, 225, 258, 238]
export const CROSS_TYPES = [
  ...WDL_MARKET_TYPES,
  ...HANDICAP_MARKET_TYPES,
  ...UNDEROVER_MARKET_TYPES,
]
export const LS_WDL_MARKET_TYPES = [1, 52, 226]
export const LS_HANDICAP_MARKET_TYPES = [3, 342, 1558]
export const LS_UNDEROVER_MARKET_TYPES = [2, 28, 835]
export const LS_CROSS_TYPES = [
  ...LS_WDL_MARKET_TYPES,
  ...LS_HANDICAP_MARKET_TYPES,
  ...LS_UNDEROVER_MARKET_TYPES,
]

// 기준점(specifier)에 선수 정보가 들어가는 Betradar 플레이어 마켓 (markets.xml 기준, 크리켓 제외)
// VARIANT: variant=pre:playerprops:<matchId>:<playerId>
export const PLAYER_PROPS_VARIANT_MARKET_TYPES = [
  719, 759, 760, 761, 762, 763, 764, 765, 766, 767, 768, 769, 770, 771, 772, 773, 774, 775, 776,
  777, 778, 779, 780, 781, 782, 783, 784, 785, 786, 787, 788, 1191, 1234, 1235, 1236, 1237, 1238,
]
// SPEC: player=sr:player:<playerId> (1549~1556은 player1·player2 등 선수 2명 이상)
export const PLAYER_PROPS_SPECIFIER_MARKET_TYPES = [
  882, 888, 889, 890, 891, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927,
  928, 929, 1053, 1054, 1083, 1084, 1085, 1152, 1183, 1185, 1187, 1189, 1300, 1301, 1302, 1303,
  1304, 1352, 1360, 1361, 1362, 1363, 1364, 1365, 1366, 1367, 1368, 1369, 1370, 1371, 1372, 1373,
  1374, 1375, 1376, 1377, 1378, 1379, 1380, 1381, 1386, 1387, 1388, 1389, 1400, 1401, 1402, 1403,
  1491, 1492, 1493, 1539, 1540, 1541, 1542, 1543, 1549, 1550, 1551, 1552, 1553, 1554, 1555, 1556,
  1573, 1574, 1783, 1784, 1785, 1786, 1787, 1788, 1789,
]
export const PLAYER_PROPS_MARKET_TYPES = [
  ...PLAYER_PROPS_VARIANT_MARKET_TYPES,
  ...PLAYER_PROPS_SPECIFIER_MARKET_TYPES,
]
// 어드민 UO 경기 상세 표시 규칙 (기획서 명시 마켓)
// 기준점은 total 값만 표시 (예 total:11.5,player:sr:player:1617710 → 11.5)
export const PLAYER_PROPS_TOTAL_ONLY_MARKET_TYPES = [921, 922, 923, 924]
// 마켓 필드(outcome)는 이름 중 'n+' 만 표시 (예 Gustafson, Megan 23+ → 23+)
export const PLAYER_PROPS_MILESTONE_OUTCOME_MARKET_TYPES = [768, 770, 771, 772, 773, 775]

export enum FAVORITE_USER_SORT {
  CREATED_AT = 'createdAt',
  LAST_MESSAGE_SENT_AT = 'lastMessageSentAt',
}

export enum FAVORITE_USER_SAVE_MODE {
  NONE = 'none',
  REGISTER_ALL = 'registerAll',
  UNREGISTER_ALL = 'unregisterAll'
}

export const MOLOCO_PIXEL_RECOMMEND_ID = 'CMU01'

export enum MOLOCO_PIXEL_EVENT {
  Registration = 'Registration',
  ViewContent = 'ViewContent',
  Purchase = 'Purchase',
}

export const TIMELINE_TEAM_TYPE = {
  HOME: 'home', AWAY: 'away',
}

export const TIMELINE_SOCCER_DISCIPLINARY_TYPE = {
  YELLOW: 'yellow_card', RED: 'red_card', YELLOW_RED: 'yellow_red_card',
}

export enum ScheduleGlobalKey {
  USER_PAYMENT_SUMMARY_LAST_TIME = 'user_payment_summary_last_time'
}

export enum REPORT_AUTH_SOURCE {
  LDAP = 'LDAP',
  LOCAL = 'LOCAL',
}
